import React from "react";
import { Link } from "@quintype/components";
import { bool, func, array, string, object } from "prop-types";

import Notifications from "../Notifications";
import Icon from "../../../icons";
import AuthView from "../../../rows/AuthView";

import { getSiteLink } from "../../../utils/utils";

import "./uniformHeader.m.css";

const LoginContainer = ({
  dot,
  toggleNotifications,
  showNotifications,
  notifications,
  showLogin,
  loginBorderStyle,
  loginTextStyle,
  bellIconStyle,
  showNotification,
  showLanguageEdition = false,
  publisherAttributes,
}) => (
  <>
    {showLanguageEdition && (
      <Link
        styleName={`language-edition-container ${publisherAttributes.lang}-current-language`}
        aria-label="language edition link"
        href={getSiteLink(publisherAttributes)}
      >
        {publisherAttributes.lang === "bn" ? "EN" : "বাংলা"}
      </Link>
    )}
    {showNotification && (
      <div styleName={`bell-container ${dot ? "new-notifications-data" : "no-notifications"}`}>
        <span styleName="bell" onClick={toggleNotifications}>
          {" "}
          <Icon type="bell" className="bell" iconStyle={{ fill: bellIconStyle }} />
        </span>
        {showNotifications && (
          <Notifications
            closeView={toggleNotifications}
            notifications={notifications}
            toggleNotifications={toggleNotifications}
          />
        )}
      </div>
    )}
    {showLogin && <AuthView borderColor={loginBorderStyle} textColor={loginTextStyle} />}
  </>
);

LoginContainer.propTypes = {
  dot: bool,
  toggleNotifications: func,
  showNotifications: bool,
  notifications: array,
  showLogin: bool,
  loginBorderStyle: string,
  loginTextStyle: string,
  bellIconStyle: string,
  showNotification: bool,
  publisherAttributes: object,
  showLanguageEdition: bool,
};

export default LoginContainer;
